import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js'

/**
 * Chart.js needs its pieces registered before a chart draws. Done here, beside
 * the charts, so anything rendering them works without the Demographics tab
 * having been imported first (MYD-499: a presentation slide). Registering
 * twice is harmless.
 */
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title)
